module.exports = __webpack_public_path__ + "img/imgxiazz.9289727b.png";